import { render, staticRenderFns } from "./commodity-edit-form.html?vue&type=template&id=4b5fea38&scoped=true&"
import script from "./commodity-edit-form.js?vue&type=script&lang=js&"
export * from "./commodity-edit-form.js?vue&type=script&lang=js&"
import style0 from "./CommodityEditForm.vue?vue&type=style&index=0&id=4b5fea38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5fea38",
  null
  
)

component.options.__file = "CommodityEditForm.vue"
export default component.exports